var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{class:_vm.cclass,domProps:{"value":_vm.value.regionId},on:{"change":_vm.onChangeRegion}},[_c('option',{attrs:{"selected":""},domProps:{"value":0}},[_vm._v("Select")]),_vm._l((_vm.regions),function(region){return _c('option',{key:region.id,domProps:{"value":region.id}},[_vm._v(" "+_vm._s(region.title)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }